import React from 'react'
import { Outlet } from 'react-router-dom'
import styles from '../sass/layout.module.scss'

const Main = () => {
  return (
    <main className={styles.Main_Container}>
        <Outlet /> {/* This will render the dynamic content */}
    </main>
  )
}

export default Main